import getCart from './getCart';
import updateCartCount from './updateCartCount';

const addToCart = async (variantId, qty) => {
  const item = {
    id: variantId,
    quantity: qty
  };

  const items = { items: [item] };

  try {
    const atc = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Theme-ATC': '1' },
      body: JSON.stringify(items)
    });

    if (!atc.ok) {
      throw new Error(`Add to cart failed with status ${atc.status}`);
    }

    const cart = await getCart();
    updateCartCount(cart.item_count);
    return await atc.json();
  } catch (err) {
    console.error('Add to cart error:', err);
    throw err;
  }
};

export default addToCart;
